import { useEffect, useState } from "react";
import { Plus } from "@phosphor-icons/react";
import { toast } from "sonner";

import { api, formatApiError } from "@/lib/api";

export function CourseDetailsEditor({ course, onChanged }) {
  const [details, setDetails] = useState(course);
  const [moduleTitle, setModuleTitle] = useState("");

  useEffect(() => setDetails(course), [course]);

  const saveDetails = async (event) => {
    event.preventDefault();
    try {
      await api.put(`/lms/courses/${course.id}`, details);
      toast.success("Course details updated");
      onChanged();
    } catch (error) {
      toast.error(formatApiError(error));
    }
  };

  const addModule = async (event) => {
    event.preventDefault();
    try {
      await api.post(`/lms/courses/${course.id}/modules`, { title: moduleTitle });
      setModuleTitle("");
      toast.success("Module added");
      onChanged();
    } catch (error) {
      toast.error(formatApiError(error));
    }
  };

  return (
    <section className="editor-section" data-testid="course-details-editor">
      <div className="editor-section-heading"><p className="eyebrow">Course settings</p><h2>Course details</h2></div>
      <form className="editor-form-grid" onSubmit={saveDetails} data-testid="edit-course-details-form">
        <label>Course title<input value={details.title} onChange={(event) => setDetails({ ...details, title: event.target.value })} data-testid="edit-course-title-input" /></label>
        <label>Category<input value={details.category} onChange={(event) => setDetails({ ...details, category: event.target.value })} data-testid="edit-course-category-input" /></label>
        <label>Duration<input value={details.duration} onChange={(event) => setDetails({ ...details, duration: event.target.value })} data-testid="edit-course-duration-input" /></label>
        <label className="editor-wide-field">Description<textarea value={details.description} onChange={(event) => setDetails({ ...details, description: event.target.value })} data-testid="edit-course-description-input" /></label>
        <button className="primary-button" data-testid="save-course-details-button">Save course details</button>
      </form>
      <form className="editor-inline-form" onSubmit={addModule} data-testid="add-module-form">
        <label htmlFor="new-module-title">New module</label>
        <input id="new-module-title" value={moduleTitle} onChange={(event) => setModuleTitle(event.target.value)} required data-testid="new-module-title-input" />
        <button className="outline-button" data-testid="add-module-button"><Plus aria-hidden="true" size={18} />Add module</button>
      </form>
    </section>
  );
}